import { render, staticRenderFns } from "./CouponDlg.vue?vue&type=template&id=2439725f&scoped=true&"
import script from "./CouponDlg.vue?vue&type=script&lang=js&"
export * from "./CouponDlg.vue?vue&type=script&lang=js&"
import style0 from "./CouponDlg.vue?vue&type=style&index=0&id=2439725f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439725f",
  null
  
)

export default component.exports